import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { isEuVisitor, getConsent, setConsent } from "../lib/analytics";

export const ConsentBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(isEuVisitor() && !getConsent()); }, []);
  if (!show) return null;
  const decide = (v) => { setConsent(v); setShow(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[990] rounded-2xl border border-black/10 bg-[#FDFBF7] shadow-xl p-5" role="dialog" aria-label="Cookie consent" data-testid="consent-banner">
      <p className="text-sm leading-relaxed">
        We use Google Analytics cookies to understand how WanderlyMe is used. No analytics run until you accept. See our{" "}
        <Link to="/privacy" className="text-[#C8553D] underline underline-offset-4" data-testid="consent-privacy-link">privacy policy</Link>.
      </p>
      <div className="flex gap-2 mt-4">
        <button onClick={() => decide("accepted")} className="px-4 py-2 rounded-full bg-[#1A3B2B] text-[#FDFBF7] text-sm" data-testid="consent-accept">Accept</button>
        <button onClick={() => decide("declined")} className="px-4 py-2 rounded-full border border-black/15 text-sm" data-testid="consent-decline">Decline</button>
      </div>
    </div>
  );
};
